/** Non-destructive brush mask in original, unmirrored image coordinates.
 * Diameter is a fraction of the shorter source edge. Restore changes only
 * this mask; it never invents pixels missing from the original alpha.
 */
export interface PhotoEraseStroke {
  mode: 'erase' | 'restore';
  diameter: number;
  points: Array<{ x: number; y: number }>;
}
export const PHOTO_ERASE_LIMITS = { strokes: 200, points: 12000, perStroke: 2000, minDiameter: .002, maxDiameter: .5 } as const;
export function parsePhotoErase(value: unknown): PhotoEraseStroke[] {
  if (!Array.isArray(value) || value.length > PHOTO_ERASE_LIMITS.strokes) throw new Error('Invalid eraser strokes');
  let count = 0;
  const number = (n: unknown, low: number, high: number): n is number => typeof n === 'number' && Number.isFinite(n) && n >= low && n <= high;
  return value.map(stroke => {
    if (!stroke || typeof stroke !== 'object' || Object.keys(stroke).some(k => !['mode','diameter','points'].includes(k)) || !['erase','restore'].includes(stroke.mode)
      || !number(stroke.diameter, .002, .5) || !Array.isArray(stroke.points) || !stroke.points.length || stroke.points.length > 2000) throw new Error('Invalid eraser stroke');
    count += stroke.points.length;
    if (count > PHOTO_ERASE_LIMITS.points) throw new Error('Too many eraser points');
    return { mode: stroke.mode, diameter: stroke.diameter, points: stroke.points.map((point: any) => {
      if (!point || typeof point !== 'object' || Object.keys(point).some(k => !['x','y'].includes(k)) || !number(point.x,0,1) || !number(point.y,0,1)) throw new Error('Invalid eraser point');
      return { x: point.x, y: point.y };
    }) };
  });
}
